import { render } from "./collection.vue?vue&type=template&id=1edf5ec6&scoped=true"
import script from "./collection.vue?vue&type=script&lang=js"
export * from "./collection.vue?vue&type=script&lang=js"

import "./collection.vue?vue&type=style&index=0&id=1edf5ec6&lang=scss&scoped=true"
import "./collection.vue?vue&type=style&index=1&id=1edf5ec6&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1edf5ec6"]])

export default __exports__